<template>
  <div :class="containerClass">
    <div
      :class="barElClass"
      :style="{ width: `${progress}%` }"
    ></div>
  </div>
</template>

<script setup>
import { nextTick, ref, watch } from 'vue';

const props = defineProps({
  value: {
    type: Number,
    default: 0,
    required: true,
  },
  containerClass: {
    type: [Object, Array, String],
    default: 'progress-container',
  },
  barElClass: {
    type: [Object, Array, String],
    default: 'progress-bar',
  },
});

const progress = ref(0);

const animateProgress = () => {
  progress.value = 0;

  nextTick(() => {
    progress.value = props.value;
  });
};

watch(() => props.value, () => {
  animateProgress();
}, { immediate: true });
</script>
